module.exports = __webpack_public_path__ + "assets/img/wbbook.2e0f2ba4.svg";